import React, { PureComponent } from 'react';
import CombinedDashboardPage from '../../presenters/dashboard/Dashboard';

class Dashboard extends PureComponent {
  render() {
    return <CombinedDashboardPage />;
  }
}

export default Dashboard;
